export default __webpack_public_path__ + "static/media/freeStorage.c3ce6e3f.svg";